export const illustrationInformationArray = [
  {
    organization: "The Washington Post",
    title:
      "Why a child’s stuffed bunny is blowing up a political race — and the internet",
    description: "",
    link: "https://www.washingtonpost.com/nation/2026/08/08/why-childs-blue-bunny-doll-is-blowing-up-political-race-internet/",

    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/illustration/bluebunny.jpg",
      },
    ],
    awards: "",
  },
  {
    organization: "Sacramento Business Journal",
    title: "Forty Under Forty",
    description:
      "Created the scultpure and worked with the photographer to get the right photo.",
    link: "",
    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/illustration/forty-layout.jpg",
      },
    ],
    awards:
      "Award of Excellence for News Page Design, Business from the Society for News Design",
  },
  {
    organization: "Sacramento Business Journal",
    title: "Best Places to Work",
    description:
      "Printed and cutout the individual pieces of the illustration, assembled them and scanned the image to get a vintage office texture.",
    link: "",
    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/illustration/bptw.jpg",
      },
    ],
    awards: "",
  },
  {
    organization: "The Washington Post",
    title: "Having trouble falling or staying asleep? Try cognitive shuffling.",
    description: "",
    link: "https://www.instagram.com/p/DWKqqH3gPGS/?img_index=1",
    illustrations: [
      {
        type: "image",
        size: "spot",
        source: "/projects/illustration/cognitiveshuffling-1.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/illustration/cognitiveshuffling-2.jpg",
      },
    ],
    awards: "",
  },
  {
    organization: "Sacramento Business Journal",
    title: "Best of the Bar",
    description: "",
    link: "",
    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/illustration/best-of-bar.jpg",
      },
    ],
    awards:
      "First place, Illustration, Print Division from the California News Publishers Association",
  },
  {
    organization: "The Washington Post",
    title: "9 tips to debunk false claims made by friends and family",
    description: "",
    link: "https://www.washingtonpost.com/wellness/2022/10/05/debunk-political-misinformation-advice/",
    illustrations: [
      {
        type: "video",
        size: "main",
        source: "/projects/illustration/disinformation-convos.mp4",
      },
    ],
    awards: "",
  },
  {
    organization: "The Washington Post",
    title: "Why do airlines hate basic economy passengers?",
    description: "",
    link: "https://www.washingtonpost.com/travel/2026/03/08/airlines-miles-basic-economy-budget/",
    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/illustration/basiceconomy.jpg",
      },
    ],
    awards: "",
  },
  {
    organization: "Sacramento Business Journal",
    title: "Heavy hitters in real estate",
    description: "",
    link: "",
    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/illustration/real-estate.jpg",
      },
    ],
    awards: "",
  },
  {
    organization: "The Seattle Times",
    title: "Digital conditioning for social distancing",
    description: "",
    link: "",
    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/illustration/social-distancing.jpg",
      },
    ],
    awards: "",
  },
];
